import { useQuery } from "react-query";
import { pos } from "@/platform";
import { useFotoDeLaCaja } from "@/context/caja/fotoDeLaCaja";

export const AJUSTES_DE_LA_FOTO_QUERY_KEY = "caja-ajustes-de-la-foto";

/**
 * Los ajustes de la foto de la caja de este negocio (#346; §2.1): los medios de
 * pago, la sobreventa, si factura, lo que imprime el ticket y los topes. Salen
 * del caché de la caja, no del servidor; cuando cambia la versión de la parte
 * `settings`, se vuelven a leer.
 */
export function useAjustesDeLaFoto(businessId: string | undefined) {
  const version = useFotoDeLaCaja(
    (s) => s.foto.partes.find((p) => p.parte === "settings")?.activa?.version
  );
  return useQuery(
    [AJUSTES_DE_LA_FOTO_QUERY_KEY, businessId, version ?? null],
    () => pos.photoSettings(businessId as string),
    {
      enabled: pos.isAvailable && !!businessId,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
    }
  );
}
